export const BRANDS = 'brands'
export const ALL_BRANDS = `${BRANDS}/ALL_BRANDS`
